module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_8019.d79d8566.png";